// extracted by mini-css-extract-plugin
export default {"activity-container":"activity_activity-container__Fqxcj","card-container":"activity_card-container__IY3t3","card_header":"activity_card_header__YXtHk"};